import React from 'react';

import Button from '../../library/button/button';
import { FileInvoiceDollarRegularIcon } from '../../shared/icons/icons';

import { useModal, useMyAccount } from '../../shared/hooks/hooks';

import { isCanonicalProduct } from '../../shared/utils/product/product';

import { ProductItem } from '../../shared/types/product';
import * as MODAL_TYPES from '../../shared/constants/modals';

import './found-it-lower-button.scss';

enum FoundItLowerTheme {
  BLUE = 'blue',
  GREY = 'grey'
}

enum FoundItLowerArrowOrientation {
  LEFT = 'left',
  RIGHT = 'right'
}

interface FoundItLowerButtonProps {
  analyticsPrefix?: string;
  arrowOrientation?: FoundItLowerArrowOrientation;
  className?: string;
  hideIcon?: boolean;
  hideMatchItText?: boolean;
  productItem: ProductItem;
  theme?: FoundItLowerTheme;
}

function FoundItLowerButton(props: FoundItLowerButtonProps) {
  const {
    analyticsPrefix = '',
    arrowOrientation,
    className,
    hideIcon = false,
    hideMatchItText = false,
    productItem,
    theme = FoundItLowerTheme.GREY
  } = props;
  const { product } = productItem || {};

  const { openModal } = useModal();
  const { isFleetAccount } = useMyAccount();

  const isCanonical = isCanonicalProduct(product);
  const { mapDisplayRule, mapRuleSatisfied } = product || {};

  if (
    isFleetAccount ||
    isCanonical ||
    (mapRuleSatisfied && !mapDisplayRule?.mapPriceDisplay)
  ) {
    return null;
  }

  return (
    <Button
      className={`${className || ''} found-it-lower-button`}
      onClick={() => {
        openModal(MODAL_TYPES.FOUND_IT_LOWER_DRAWER, {
          analyticsPrefix,
          productItem
        });
      }}
      styleName={`found-it-lower-${theme} ${
        arrowOrientation ? `arrow-${arrowOrientation}-container` : ''
      }`}
    >
      {arrowOrientation === FoundItLowerArrowOrientation.LEFT && (
        <div styleName="arrow-left" />
      )}
      {!hideIcon && <FileInvoiceDollarRegularIcon />}
      Found a lower price? {!hideMatchItText && "We'll match it!"}
      {arrowOrientation === FoundItLowerArrowOrientation.RIGHT && (
        <div styleName="arrow-right" />
      )}
    </Button>
  );
}

export { FoundItLowerArrowOrientation, FoundItLowerTheme };
export default FoundItLowerButton;
